import React from 'react';
import Modal from 'react-modal';

import Button from 'components/atoms/Button';
import Heading from 'components/atoms/Heading';
import Icon from 'components/atoms/Icon';
import Text from 'components/atoms/Text';
import mapModifiers from 'utils/functions';

export type NotifyType = 'success' | 'error';

export interface NotifyProps {
  isOpen?: boolean;
  handleClose: () => void;
  type?: NotifyType;
  title?: string;
  message?: string;
  btnText?: string;
  subBtnText?: string;
  handleConfirm?: () => void;
  handleSubBtn?: () => void;
}

export interface NotifyState {
  isOpen: boolean,
  title?: string,
  message?: string,
  type?: 'success' | 'error',
  btnText?: string;
  subBtnText?: string;
  handleConfirm?: () => void;
  handleSubBtn?: () => void;
}

const Notify: React.FC<NotifyProps> = ({
  isOpen = false,
  handleClose,
  type = 'success',
  title,
  message,
  btnText = 'Ok',
  handleConfirm,
  subBtnText,
  handleSubBtn,
}) => {
  const headingColor = type === 'success' ? 'primaryReverseLinear' : 'sinopia' as ColorStyle;
  const buttonColor = type === 'success' ? 'primaryLinearReverse' : 'error' as ColorStyle;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      closeTimeoutMS={250}
      className="o-notify"
      appElement={document.getElementById('root') as HTMLElement}
      ariaHideApp={false}
      portalClassName={mapModifiers('o-notify_portal', isOpen && 'open')}
    >
      <div className="o-notify_main">
        <div className="o-notify_wrapper">
          <div className="o-notify_icon">
            <Icon iconName={type === 'success' ? 'notifySuccess' : 'notifyError'} size="60" />
          </div>
          {title && (
            <Heading
              type="h6"
              modifiers={['700', 'letterSpacing', headingColor, 'center']}
              content={title}
            />
          )}
          {message && (
            <div className="o-notify_message">
              <Text modifiers={['davysGrey', '400', 'center']} content={message} />
            </div>
          )}
          <div className="o-notify_btn">
            {subBtnText && (
              <Button
                handleClick={() => {
                  handleClose();
                  if (handleSubBtn) handleSubBtn();
                }}
                modifiers={['outline', '700', 'uppercase', 'pd-x-16']}
              >
                {subBtnText}
              </Button>
            )}
            <Button
              handleClick={() => {
                handleClose();
                if (handleConfirm) handleConfirm();
              }}
              modifiers={[buttonColor, '700', 'uppercase', 'white', 'pd-x-16']}
            >
              {btnText}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
Notify.defaultProps = {
  isOpen: false,
  type: 'success',
  title: '',
  message: '',
  btnText: 'Ok',
  handleConfirm: undefined,
  subBtnText: '',
  handleSubBtn: undefined,
};

export default Notify;
